export const educationData = [
    {
        id: 1,
        institution: 'Ozias Davhana Secondary School',
        course: 'Higher Secondary Education',
        startYear: '2010',
        endYear: '2015'
    },
    {
        id: 2,
        institution: 'Vhembe Tvet College',
        course: 'Electrical Engineering',
        startYear: '2017',
        endYear: '2018'
    },
    {
        id: 3,
        institution: 'ALX',
        course: 'Software engineering',
        startYear: '2023',
        endYear: 'Present'
    },
]